import React from 'react'
import { View, Image, Text, StyleSheet } from '@react-pdf/renderer';
import logo from '../images/MegaLogo.png';

// Create styles
const styles = StyleSheet.create({
    
    section: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '10vh',
      width: '100%',
      flex: '1.5',
      marginBottom: '5px',
    },
    logoView: {
        padding: '10px',
    },
    img: {
        width: '100px',
        height: '50px',
        padding: '5px',
    },
    heading: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px',
    },
    headingText: {
        fontSize: '15px',
        padding: '2px',
        fontFamily: 'Helvetica-Bold',
    }
  });

const PdfHeader = () => {
    return (
        <View fixed style={styles.section}>
            <View style={styles.logoView}>
                <Image style={styles.img} src={logo} 
                    alt = 'Mega Logo'>
                </Image>
            </View>
            <View style={styles.heading}>
                <Text style={styles.headingText}>MEGA PLAZA INVESTMENT LIMITED</Text>
                <Text style={styles.headingText}>Payment Voucher</Text>
            </View>

            <View style={styles.logoView}>
                <Image style={styles.img} src={logo} 
                    alt = 'Mega Logo'>

                </Image>
            </View>
        </View>
    )
}

export default PdfHeader
